<template>
  <div
    class="comp-container__bottom"
    :class="{
      'show-chat': showChat,
      'hide-chat': !showChat,
    }"
  >
    <send-message class="send-message-box" :isReady="isReady" />
    <div class="menu-box">
      <div
        @click="handleMenuClick(item.key)"
        class="menu-item"
        :class="{
          'is-active-chat': item.key === 'chat' && showChat,
        }"
        v-for="item in showMenuList"
        :key="item.key"
        v-preventReClick
      >
        <template v-if="item.key === 'board'">
          <el-tooltip
            popper-class="live-room-tooltip"
            effect="dark"
            :content="`第${currentPage}/${totalPages}页`"
            placement="top"
            :disabled="!currentPage || !totalPages"
          >
            <img :src="item.img" />
          </el-tooltip>
          <div class="label">{{ item.label }}</div>
        </template>
        <mic-selector
          v-else-if="
            item.key === 'audio' &&
            ((!isScreenShare && isElectron) || !isElectron)
          "
        ></mic-selector>
        <camera-selector
          v-else-if="
            item.key === 'video' &&
            ((!isScreenShare && isElectron) || !isElectron)
          "
        ></camera-selector>
        <template v-else-if="item.key === 'chat'">
          <div class="icon-wrapper">
            <img :src="item.img" />
            <!-- <span v-if="privateUnread > 0" class="unread-badge">{{
              privateUnread > 99 ? "99+" : privateUnread
            }}</span> -->
          </div>
          <div class="label">{{ item.label }}</div>
        </template>
        <el-dropdown v-else-if="item.key === 'more'" @command="handleMore">
          <img :src="item.img" />
          <div class="label">{{ item.label }}</div>
          <el-dropdown-menu slot="dropdown" class="device-dropdown-menu">
            <el-dropdown-item :command="'deviceCheck'">
              设备检测
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <template v-else>
          <img :src="item.img" />
          <div class="label">{{ item.label }}</div>
        </template>
      </div>
    </div>
    <div class="handle-box">
      <!-- <el-button @click="testButtonClick">测试按钮</el-button> -->
      <el-dropdown v-if="!roomInfo.isStudent" @command="handleLeaveRoom">
        <el-button class="endclass-btn">下课</el-button>
        <el-dropdown-menu slot="dropdown" class="roster-dropdown-menu">
          <el-dropdown-item :command="'owner'" :class="{ active: !isDelay }">
            仅自己离开
          </el-dropdown-item>
          <el-dropdown-item :command="'all'" :class="{ active: isDelay }">
            全员下课
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button class="endclass-btn" v-else @click="onClickEndClass"
        >下课</el-button
      >
    </div>
    <handle-end-class ref="handleEndClass"></handle-end-class>
    <no-permsion ref="noPermsion"></no-permsion>
  </div>
</template>

<script>
import SendMessage from "./SendMessage.vue";
import { mapMutations, mapState } from "vuex";
import { stopLive } from "@saas/server-api/src/live-sdk";
import { uploadLiveLog } from "@saas/components/src/utils/log";
import NoPermsion from "../dialog/NoPermsion.vue";
import MicSelector from "./MicSelector.vue";
import CameraSelector from "./CameraSelector.vue";
import { closeWindow } from "@saas/components/src/utils/utils";
import HandleEndClass from "../dialog/HandleEndClass.vue";
import { fileImagebyFileName, isImage, isVideo, isDoc } from "@saas/components";
export default {
  components: {
    SendMessage,
    NoPermsion,
    MicSelector,
    CameraSelector,
    HandleEndClass,
  },
  props: {},
  data() {
    return {
      menuList: [
        {
          key: "audio",
          img: require("@saas/pages/assets/images/live/micro.png"),
          label: "音频",
        },
        {
          key: "video",
          img: require("@saas/pages/assets/images/live/video.png"),
          label: "视频",
        },
        {
          key: "chat",
          img: require("@saas/pages/assets/images/live/chat.png"),
          label: "消息",
        },
        {
          key: "roster",
          img: require("@saas/pages/assets/images/live/users.png"),
          label: "花名册",
        },
        {
          key: "share",
          img: require("@saas/pages/assets/images/live/screen-share.png"),
          label: "共享",
        },
        {
          key: "board",
          img: require("@saas/pages/assets/images/live/board.png"),
          label: "白板",
        },
        {
          key: "courseware",
          img: require("@saas/pages/assets/images/live/course-file.png"),
          label: "课件",
        },
        {
          key: "sale",
          img: require("@saas/pages/assets/images/live/sale.png"),
          label: "直播售卖",
        },
        // {
        //   key: "testCourseware",
        //   img: require("@saas/pages/assets/images/live/course-file.png"),
        //   label: "测试转码",
        // },
        {
          key: "more",
          img: require("@saas/pages/assets/images/live/more.png"),
          label: "更多",
        },
      ],
      studentMenuList: [
        {
          key: "audio",
          img: require("@saas/pages/assets/images/live/micro.png"),
          label: "音频",
        },
        {
          key: "video",
          img: require("@saas/pages/assets/images/live/video.png"),
          label: "视频",
        },
        {
          key: "chat",
          img: require("@saas/pages/assets/images/live/chat.png"),
          label: "消息",
        },
      ],
      showTranscodeInfoDialog: false,
      endClassVisible: false,
      currentPage: 1,
      totalPages: 1,
      isElectron: window.isElectron,
      id: null,
      lessonId: null,
    };
  },
  computed: {
    ...mapState("live", [
      "isReady",
      "layout",
      "liveService",
      "imService",
      "deviceSwtich",
      "roomInfo",
      "userStatus",
      "isDelay",
      "screenShareStatus",
      "screenPermission",
      "showRoster",
      "showScreenShareDialog",
      "showSet",
      "remoteScreenShareInfo",
      "whiteBoardService",
      "whiteboardType",
    ]),
    ...mapState("newChat", ["showChat", "chatMode", "privateUnread"]),
    showMenuList() {
      let menuList = [];
      if (!this.roomInfo.isStudent) {
        menuList = this.menuList;
      } else {
        menuList = this.studentMenuList;
      }
      if (this.roomInfo.mode != 1) {
        return menuList;
      }
      return menuList.filter((item) => !["share", "video"].includes(item.key));
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    isScreenShare() {
      return ["start", "pause"].includes(this.screenShareStatus);
    },
    // 是否在接收共享（）
    isScreenShareRemote() {
      return ["start", "pause"].includes(this.remoteScreenShareInfo.status);
    },
    // 课件列表
    coursewareList() {
      return this.roomInfo.doc || [];
    },
  },
  mounted() {
    this.lessonId = +this.$route.params.lessonId || "";
  },
  watch: {
    "$store.state.whiteBoard.currentFileInfo": {
      immediate: true,
      handler(newValue) {
        if (newValue && this.whiteboardType === "whiteboard") {
          this.currentPage = newValue.currentPageIndex + 1;
          this.totalPages = newValue.pageCount;
        }
      },
    },
  },
  methods: {
    ...mapMutations("live", [
      "setRoomInfo",
      "setScreenShareStatus",
      "setShowRoster",
      "setShowScreenShareDialog",
      "setShowSet",
      "setShowCourseSale",
      "setShowDeviceCheck",
      "setWhiteboardType",
      "setShowUploadCourseware",
    ]),
    ...mapMutations("newChat", ["SET_SHOW_CHAT", "SET_CHAT_MODE"]),
    handleMenuClick(key) {
      uploadLiveLog({
        message: `用户点击底部菜单_${key}`,
      });
      if (key === "roster") {
        this.setShowRoster(!this.showRoster);
      } else if (key === "share") {
        this.onClickShare();
      } else if (key === "chat") {
        this.SET_SHOW_CHAT(!this.showChat);
        // 处理关闭独立聊天窗口
        if (window.isElectron && !this.showChat && this.chatMode === "popup") {
          window.ipcRenderer.send("chat-close-window");
          this.SET_CHAT_MODE("embed");
        }
        // 处理打开
        if (this.showChat) {
          this.SET_CHAT_MODE("embed");
        }
      } else if (key === "more") {
        // this.setShowSet({
        //   visible: !this.showSet.visible,
        // });
      } else if (key === "courseware") {
        this.onClickCourseware();
      } else if (key === "board") {
        this.onClickWhiteboard();
      } else if (key === "sale") {
        this.onClickCourseSale();
      }
    },
    handleUpdateWhiteboardType(type) {
      this.setWhiteboardType(type);
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "whiteboardType",
          data: {
            type: type,
          },
        },
      });
    },
    handleOpenUploadDialog() {
      this.showTranscodeInfoDialog = false;
    },
    handleCloseDialogs() {
      this.showTranscodeInfoDialog = false;
    },
    handleLeaveRoom(type) {
      if (type === "owner") {
        this.liveService.exitRoom();
        closeWindow();
      } else {
        if (this.isDelay) {
          this.handleEndLive().then((res) => {
            if (res.code === 1 || res.code === 21003) {
              this.afterEndClass();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$refs.handleEndClass.open();
        }
      }
    },
    afterEndClass() {
      if (this.isElectron) {
        window.ipcRenderer.send("end-class", {
          lessonId: this.lessonId,
          courseId: this.roomInfo.course_id,
        });
        closeWindow();
      } else {
        const url =
          "/live-list?liveover=1&lessonid=" +
          this.lessonId +
          "&courseid=" +
          this.roomInfo.course_id;
        window.location.href = url;
      }
    },
    handleEndLive() {
      this.imService.sendMGLiveRoomCustomMsg({
        cmdId: 2,
        data: {
          type: "endLive",
        },
      });
      return stopLive({
        room_id: this.roomInfo.id,
      });
    },
    onClickEndClass() {
      this.liveService.exitRoom();
      closeWindow();
    },
    // 当点击白板
    onClickWhiteboard() {
      if (
        this.roomInfo.isAssistant &&
        this.userStatus.is_up_stage !== 1 &&
        this.roomInfo.is_quick_live === 1
      ) {
        this.$darkMessage.error("上台后才能操作");
        return;
      }
      if (this.isScreenShareRemote) {
        //
        this.$darkMessage.error("共享状态下，无法进行白板及课件的使用");
        return;
      }
      this.handleUpdateWhiteboardType("whiteboard");
      this.whiteBoardService.switchFile("#DEFAULT");
    },
    onClickCourseSale() {
      this.setShowCourseSale(true);
    },
    // 当点击课件
    onClickCourseware() {
      if (
        this.roomInfo.isAssistant &&
        this.userStatus.is_up_stage !== 1 &&
        this.roomInfo.is_quick_live === 1
      ) {
        this.$darkMessage.error("上台后才能操作");
        return;
      }
      if (this.isScreenShareRemote) {
        //
        this.$darkMessage.error("共享状态下，无法进行白板及课件的使用");
        return;
      }
      // 如果当前直播有课件，就展示默认课件，否则展示上传课件弹窗
      if (this.coursewareList.length) {
        const cacheCourseware = JSON.parse(
          localStorage.getItem("lastCourseware") || "{}"
        );
        if (
          cacheCourseware.id === this.roomInfo.id &&
          cacheCourseware.fileId &&
          this.coursewareList.some(
            (item) => item.roomFileId === cacheCourseware.fileId
          )
        ) {
          console.log("cacheCourseware____clickCourseware", cacheCourseware);
          // 属于当前直播间并且课件列表有这个课件
          const fileId = cacheCourseware.fileId;
          console.log("cacheCourseware____fileId", fileId);
          this.whiteBoardService.switchFile(fileId);
        } else {
          const file = this.coursewareList[0];
          console.log("cacheCourseware____file", file);
          if (file.roomFileId) {
            console.log("cacheCourseware____file.roomFileId", file.roomFileId);
            this.whiteBoardService.switchFile(file.roomFileId);
          } else {
            let id = null;
            if (isVideo(file.doc_name)) {
              id = this.whiteBoardService.addVideoFile({
                url: file.transcode_result,
                title: file.doc_name,
              });
              file.fileId = id;
              this.whiteBoardService.switchFile(id);
            } else if (isImage(file.doc_name)) {
              id = this.whiteBoardService.addImagesFile({
                urls: [file.transcode_result],
                title: file.doc_name,
              });
              file.fileId = id;
              this.whiteBoardService.switchFile(id);
            } else {
              id = this.whiteBoardService.addTranscodeFile({
                pages: file.pages,
                url: file.transcode_result,
                title: file.doc_name,
                resolution: file.resolution,
              });
            }
            console.log("cacheCourseware____file.add", id);
            this.whiteBoardService.switchFile(id);
          }
        }
        this.handleUpdateWhiteboardType("courseware");
      } else {
        this.setShowUploadCourseware(true);
      }
    },
    // 当点击共享
    onClickShare() {
      if (
        this.roomInfo.isAssistant &&
        this.userStatus.is_up_stage !== 1 &&
        this.roomInfo.is_quick_live === 1
      ) {
        this.$darkMessage.error("上台后才能共享");
        return;
      }
      if (this.isScreenShareRemote) {
        this.$darkMessage.error("其他老师正在共享，此时无法发起共享");
        return;
      }
      if (window.isElectron) {
        if (this.screenPermission) {
          this.setShowScreenShareDialog(!this.showScreenShareDialog);
        } else {
          if (this.isMac()) {
            this.$refs.noPermsion.open();
          }
        }
      } else {
        if (this.liveService) {
          if (this.screenShareStatus != "end") {
            this.liveService.stopScreenCapture();
            this.setScreenShareStatus("end");
            return;
          }
          this.liveService
            .startScreenCapture()
            .then(() => {
              if (this.isScreenShareRemote) {
                this.$darkMessage.error("其他老师正在共享，此时无法发起共享");
                this.liveService.stopScreenCapture();
              } else {
                this.liveService
                  .updateScreenShare({
                    publish: true,
                  })
                  .then((res) => {
                    this.setScreenShareStatus("start");
                  })
                  .catch((err) => {
                    console.error("屏幕更新共享", err);
                  });
              }
            })
            .catch((err) => {
              console.error("屏幕共享", err);
            });
        } else {
          console.log("liveService 服务获取失败");
        }
      }
    },
    isMac() {
      console.log(window.navigator.platform.toUpperCase().indexOf("MAC") >= 0);
      return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    },
    handleMore(type) {
      if (type === "deviceCheck") {
        this.setShowDeviceCheck({
          visible: true,
          type: "handle",
        });
      }
    },
    testButtonClick() {
      window.LiveElectronApi.getSourceList(this.liveService);
    },
  },
};
</script>

<style scoped lang="scss">
$menu-between-min-width: 62px;
$menu-between-max-width: 228px;
.comp-container__bottom ::v-deep {
  width: 100%;
  height: 52px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &.hide-chat {
    .handle-box {
      min-width: $menu-between-max-width;
    }
  }
  &.show-chat {
    .send-message-box {
      min-width: $menu-between-min-width;
    }
  }
  .send-message-box {
    // flex: 3;
  }
  .handle-box {
    // flex: 1;
    display: flex;
    justify-content: flex-end;
  }
  .menu-box {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 500px;
    .menu-item {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-direction: column;
      justify-content: center;
      min-width: 46px;
      height: 46px;
      border-radius: 6px;
      margin: 0 6px;
      &.is-active-chat {
        background: #27272a;
      }
      img {
        width: 24px;
        height: 24px;
      }
      .icon-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .unread-badge {
          position: absolute;
          top: -5px;
          left: 14px;
          min-width: 20px;
          height: 20px;
          background: #f53f3f;
          border-radius: 100px 100px 100px 100px;
          border: 2px solid #18181b;
          font-weight: 500;
          font-size: 12px;
          color: #ffffff;
          line-height: 1;

          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 3px;
        }
      }
      .label {
        margin-top: 1px;
        font-size: 12px;
        font-weight: 500;
        font-size: 11px;
        color: #ecedee;
      }
    }
  }
}
.roster-dropdown-menu,
.device-dropdown-menu ::v-deep {
  // width: 119px;
  height: 104px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  padding: 11px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .popper__arrow {
    display: none;
  }
  li {
    width: 118px;
    height: 36px;
    background: #27272a;
    border-radius: 10px 10px 10px 10px;
    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;
    height: 36px;
    // border-bottom: 1px solid rgba(229, 231, 235, 0.04);
    display: flex;
    align-items: center;
    justify-content: center;
    // margin-bottom: 11px;
    &.active {
      background: #cb2634;
      &:hover {
        background: #cb2634;
      }
    }
    &:last-child {
      border-bottom: none;
      margin-bottom: 0 !important;
    }
    &:hover {
      background: #27272a;
      color: #ecedee;
    }
  }
  .remove {
    &:hover {
      color: #f53f3f;
    }
  }
}
.device-dropdown-menu {
  height: auto;
}
.endclass-btn {
  width: 62px;
  height: 36px;
  background: #cb2634;
  border-radius: 12px 12px 12px 12px;
  font-size: 14px;
  color: #ffece8;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: #cb2634;
  }
}
</style>
